if (typeof BSS_B2B !== "undefined" && BSS_B2B) {
    setTimeout(() => {
        const observer = new MutationObserver((MutationList) => {
            // console.log(MutationList)
            for (let item of MutationList) {
                if (item.target.classList.contains('quick-add__product-details')) {
                   document.dispatchEvent(new Event(`bss_b2b:QuickviewLoaded`))
                }
                if (item.target.id === 'cart-icon-bubble') {
                   BSS_B2B.observer.cartSubject.listenCartCheckout()
                }                
            }
        })
        observer.observe(document.body, {
            childList: true,
            subtree: true
        })
    }, 300)
}